import { AvvirEvent } from "type_aliases";

export type IntegrationPushClickedEvent = AvvirEvent<typeof INTEGRATION_PUSH_CLICKED, {
  platform: string
}>

const integrationPushClicked = (platform: string): IntegrationPushClickedEvent => ({
  type: INTEGRATION_PUSH_CLICKED,
  payload: { platform }
});

export const INTEGRATION_PUSH_CLICKED = "integration_push_clicked";

export default integrationPushClicked;
